import { Link, Outlet } from "react-router-dom";
import './Wiki.css';
import { useTranslation } from "react-i18next";
import { ReactNode } from "react";

function Wiki(): ReactNode {
    const { t } = useTranslation('base');

    return (
        <div className='max-width text-page-padding'>
            <div className='wiki'>
                <div className='wiki-grid' style={{}}>
                    <nav className='wiki-nav'>
                        <Link
                            style={{ display: "block" }}
                            to={`/wiki/${"QuickStart"}`}
                            key={"invoicenumber"}
                        >
                            {t('fast_start')}
                        </Link>
                        <Link
                            style={{ display: "block" }}
                            to={`/wiki/${"ogn"}`}
                            key={"invoicenumber"}
                        >
                            {t('ogn')}
                        </Link>
                    </nav>
                    <div className='wiki-content'>
                        <Outlet />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Wiki;